const SIGNATURE_STORAGE_KEY = "deliverySignature";

export const loginUser =  (state, {user, idToken})=>{
    const storedSignature = localStorage.getItem(SIGNATURE_STORAGE_KEY) || '';
    const signature = user?.signature || storedSignature;

    localStorage.setItem('idToken', idToken)
    state.idToken = idToken
    
    state.user = {
        ...user,
        signature
    }
    if(signature){
        localStorage.setItem(SIGNATURE_STORAGE_KEY, signature)
    } else {
        localStorage.removeItem(SIGNATURE_STORAGE_KEY)
    }
    state.status = 'authenticated'
    
}

export const logout =  (state)=>{
    state.user = null
    state.idToken = null
    state.status = 'not-authenticated'
    localStorage.removeItem('idToken')
    localStorage.removeItem('deliveryId')
    localStorage.removeItem(SIGNATURE_STORAGE_KEY)
    
 }
 export const changeSignature =  (state, signature)=>{
    if(!state.user) return;

    state.user = {
        ...state.user,
        signature
    }

    if(signature){
        localStorage.setItem(SIGNATURE_STORAGE_KEY, signature)
    } else {
        localStorage.removeItem(SIGNATURE_STORAGE_KEY)
    }
 }
